import script from "./UiTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTable.vue?vue&type=script&setup=true&lang=js"

import "./UiTable.vue?vue&type=style&index=0&id=3794263f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3794263f"]])

export default __exports__